<template>
  <div class="e4s-flex-row e4s-gap--small">
    <a v-if="getDisplayPo10" :href="getHref" target="e4s-po10" style="height: 18px">
      <span v-if="showPreText">
        <slot name="pre-text">Link to athlete on Power of Ten</slot>
      </span>
      <img :src="poImage" :style="'height: ' + imageHeight" alt="Power of ten" />
    </a>
    <PrimaryLink
      v-if="getDisplayPo10 && showUrnLink"
      :link="getHref"
      :link-text="getUrn"
      target="e4s-po10"
    />
  </div>
</template>
<script setup lang="ts">
import PrimaryLink from '@/common/ui/href/PrimaryLink.vue'
import { computed } from 'vue'
import { POWER_OF_TEN_ATHLETE_LINK } from '@/common/common-config'

import poImage from '../../assets/images/po10-red-transparent.gif'

const props = defineProps({
  urn: [String, Number],
  imageHeight: {
    type: String,
    default: () => {
      return '18px'
    }
  },
  showPreText: {
    type: Boolean,
    default: false
  },
  showUrnLink: {
    type: Boolean,
    default: false
  }
})

const getUrn = computed(() => {
  return props.urn && props.urn.toString().length > 0 ? props.urn.toString() : ''
})

const getDisplayPo10 = computed(() => {
  // const useAoCode =
  //   props.athleteAoCode.length === 0
  //     ? configStore.configApp.defaultao.code
  //     : props.athleteAoCode
  // return getUrn.value.length > 0 && useAoCode === 'EA'
  return getUrn.value.length > 0
})

const getHref = computed(() => {
  return POWER_OF_TEN_ATHLETE_LINK + getUrn.value
})
</script>
